module.exports = __webpack_public_path__ + "media/bundles/trash-var-solid25-c999b69f.png";